// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"a9048a8a","584":"ae0461d9","724":"7edf7ab3","759":"01f27cd6"}[chunkId] + ".chunk.js";
};